import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'

export default class Modal extends Component {
    static propTypes = {
        allowClose: PropTypes.bool,
        children: PropTypes.node,
        closeButton: PropTypes.bool,
        error: PropTypes.bool,
        footer: PropTypes.node,
        footerActions: PropTypes.shape({
            center: PropTypes.node,
            left: PropTypes.node,
            right: PropTypes.node,
        }),
        header: PropTypes.node,
        onClose: PropTypes.func,
        open: PropTypes.bool,
        size: PropTypes.string,
        subFooter: PropTypes.node,
        title: PropTypes.string,
    }

    static defaultProps = {
        allowClose: true,
        closeButton: true,
        error: false,
        open: false,
    }

    state = {
        title: null,
    }

    componentWillReceiveProps(nextProps) {
        // Clear the current state by iterating through the keys and creating a new object with the
        // same keys set to null
        if (nextProps.open !== true) {
            this.setState(
                Object.keys(this.state).reduce(
                    (acc, key) => {
                        acc[key] = null
                        return acc
                    },
                    {}
                )
            )
        }
    }

    modalClicked = (e) => {
        if (this.props.allowClose) {
            if (e.target.classList.contains('dialog--modal')) {
                this.props.onClose()
            }
        }
    }

    onModalHook = (config) => {
        this.setState(config)
    }

    render() {
        let closeButton = null

        if (this.props.allowClose && this.props.closeButton) {
            closeButton = (
                <div className="dialog-header__action dialog-header__action--right">
                    <a
                        className="dialog-header__action-btn"
                        href="#close"
                        onClick={ (e) => {
                            e.preventDefault()
                            this.props.onClose()
                        } }
                    >
                        <span className="fa fa-times" />
                    </a>
                </div>
            )
        }

        const headerContent = this.state.header || this.props.header
        let header = null

        if (headerContent) {
            header = (
                <div className="dialog__header dialog-header">
                    <div className="dialog-header__title dialog-header__title--center">
                        { headerContent }
                    </div>
                </div>
            )
        } else {
            header = (
                <div className="dialog__header dialog-header">
                    <div className="dialog-header__title dialog-header__title--center">
                        <h3>{ this.state.title || this.props.title }</h3>
                    </div>
                    { closeButton }
                </div>
            )
        }

        let footer = null

        let footerContent = this.state.footer || this.props.footer
        const footerActions = this.state.footerActions || this.props.footerActions

        if (footerActions) {
            const actionComponents = []

            if (footerActions.left) {
                actionComponents.push(
                    <div className="dialog-footer__actions dialog-footer__actions--left" key="left">
                        { footerActions.left }
                    </div>
                )
            }
            if (footerActions.center) {
                actionComponents.push(
                    <div className="dialog-footer__actions dialog-footer__actions--center" key="left">
                        { footerActions.center }
                    </div>
                )
            }
            if (footerActions.right) {
                actionComponents.push(
                    <div className="dialog-footer__actions dialog-footer__actions--right" key="left">
                        { footerActions.right }
                    </div>
                )
            }
            footerContent = (
                <div>
                    { footerContent }
                    { actionComponents }
                </div>
            )
        }

        if (footerContent) {
            footer = (
                <div className="dialog__footer dialog-footer">
                    { footerContent }
                </div>
            )
        }

        let subFooter = null

        if (this.props.subFooter) {
            const subFooterClasses = classnames({
                'dialog__content--post': true,
                'dialog__content--center': true,
            })

            subFooter = (
                <div className={ subFooterClasses }>
                    { this.props.subFooter }
                </div>
            )
        }

        const modalClasses = classnames({
            'dialog': true,
            'dialog--modal': true,
            'dialog--modal-open': this.props.open,
            'dialog--small': this.props.size === 'small',
            'dialog--large': this.props.size === 'large',
            'dialog--error': this.props.error,
        })

        const modalContentClasses = classnames({
            'dialog__content': true,
        })

        let children = null

        if (React.Children.count(this.props.children) === 1) {
            children = React.cloneElement(
                React.Children.only(this.props.children),
                {
                    closeModal: this.props.onClose,
                    modalHook: this.onModalHook,
                }
            )
        }

        return (
            <div className={ modalClasses } onClick={ this.modalClicked }>
                <div className={ modalContentClasses }>
                    { header }
                    <div className="dialog__body dialog__body--padded">
                        { children }
                    </div>
                    { footer }
                </div>

                { subFooter }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/modal.js